<template>
  <div>
    <slot name="activate" :open-dialog="openDialog" />

    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text class="font-16 font-black">
          <div class="d-flex align-center gap-12 mb-4">
            <i class="rd-store font-32 font-red"></i>
            <div>
              <section class="font-20 font-w-500">
                {{ bpDetail.bp_name || '-' }}
              </section>
              <section class="font-16 font-grey">
                {{ bpDetail.ScgBPNumber || '-' }}
              </section>
            </div>
          </div>
          <div class="mb-4">
            <span class="font-grey">รายละเอียดงาน : </span>
            <span>{{ data.detail || '-' }}</span>
          </div>
          <div
            class="d-flex flex-wrap mb-4"
            style="border-radius: 8px; background: #f9f9f9"
          >
            <div class="flex-grow-1 flex-shrink-0 pa-4">
              <section class="font-14 font-grey">จังหวัด/อำเภอ</section>
              <section>
                {{ bpDetail.bp_province || '-' }}/{{
                  bpDetail.bp_district || '-'
                }}
              </section>
            </div>
            <div class="flex-grow-1 flex-shrink-0 pa-4">
              <section class="font-14 font-grey">ประเภทงาน</section>
              <section>{{ data.task_type_name || '-' }}</section>
            </div>
            <div class="flex-grow-1 flex-shrink-0 pa-4">
              <section class="font-14 font-grey">กำหนดเสร็จ</section>
              <section>{{ data.due_date || '-' }}</section>
            </div>
          </div>
          <div v-if="data.task_type === '3'" class="mb-4">
            <div class="d-flex align-center gap-12 mb-4">
              <div class="d-flex align-center gap-12">
                <i class="rd-coins font-32 font-red"></i>
                <section class="font-18 font-w-500">ประเภทเสนอราคา</section>
              </div>
              <div
                v-if="mode === 'show' && data.winloss === '1'"
                class="task-type--win"
              >
                Win
              </div>
              <div
                v-if="mode === 'show' && data.winloss === '2'"
                class="task-type--loss"
              >
                Loss
              </div>
            </div>
            <div v-if="mode === 'create'" class="d-flex flex-wrap gap-12">
              <section
                class="bid-type"
                :class="{ 'bid-type--active': bidStatus === '1' }"
                @click="bidStatus = '1'"
              >
                Win
              </section>
              <section
                class="bid-type"
                :class="{ 'bid-type--active': bidStatus === '2' }"
                @click="bidStatus = '2'"
              >
                Loss
              </section>
            </div>
            <div
              v-if="mode === 'create' && bidStatus === '2'"
              class="d-flex flex-wrap gap-12 align-center my-4"
            >
              <section class="flex-shrink-0" style="flex: 1">
                <span class="font-14">กรุณาเลือกหมายเหตุ</span>
                <span class="font-red">*</span>
              </section>
              <section class="flex-shrink-0" style="flex: 2">
                <v-form ref="formRef">
                  <v-select
                    v-model="reasonGroupId"
                    :items="reasonGroupList"
                    item-text="name"
                    item-value="id"
                    :rules="[(v) => !!v]"
                    color="#a9182a"
                    placeholder="หมายเหตุ"
                    append-icon="mdi-chevron-down"
                    outlined
                    dense
                    hide-details
                  ></v-select>
                </v-form>
              </section>
            </div>
            <div v-if="mode === 'show' && data.winloss === '2'">
              <section>{{ data.reason_group_name || '-' }}</section>
            </div>
          </div>
          <div>
            <div class="d-flex align-center gap-12 mb-2">
              <i class="rd-file-note font-32 font-red"></i>
              <section class="font-18 font-w-500">หมายเหตุ</section>
            </div>
            <div class="pa-3" style="border-radius: 4px; background: #fafafa">
              <div
                v-if="mode === 'create'"
                class="d-flex align-center mb-3 gap-8"
              >
                <section>
                  <input
                    class="d-none"
                    ref="fileRef"
                    type="file"
                    accept="image/*"
                    @change="fileChange"
                  />
                  <button class="btn-box" @click="$refs.fileRef.click()">
                    <i class="rd-picture font-22 font-red"></i>
                  </button>
                </section>
                <section>
                  <button
                    v-if="isRecording"
                    class="btn-box"
                    @click="voiceRecorderStop"
                  >
                    <v-icon size="20" color="#a9182a"
                      >mdi-stop-circle-outline</v-icon
                    >
                  </button>
                  <button v-else class="btn-box" @click="voiceRecorderStart">
                    <v-icon size="20" color="#a9182a">mdi-microphone</v-icon>
                  </button>
                </section>
              </div>

              <textarea
                v-if="mode === 'create'"
                v-model="note"
                class="todo-textarea"
                placeholder="ระบุหมายเหตุ"
              ></textarea>

              <textarea
                v-if="mode === 'show'"
                :value="data.reason_detail"
                class="todo-textarea"
                placeholder="ระบุหมายเหตุ"
                readonly
              ></textarea>

              <v-row>
                <v-col
                  v-for="(item, index) in imgPreview"
                  :key="index"
                  cols="3"
                  style="position: relative"
                >
                  <DialogImgPreview :src="item.file_img">
                    <template #activate="{ openDialog }">
                      <img
                        class="img-upload"
                        :src="item.file_img"
                        alt=""
                        @click="openDialog()"
                      />
                    </template>
                  </DialogImgPreview>
                  <section
                    v-if="mode === 'create'"
                    class="img-upload-remove"
                    @click="removeImg(index)"
                  >
                    <i class="rd-trash font-red"></i>
                  </section>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-card-text>
        <v-card-actions class="justify-center gap-12 pb-6">
          <button
            v-if="mode === 'create'"
            class="btn-red-outline"
            style="width: 140px; height: 45px"
            @click="dialog = false"
          >
            ยกเลิก
          </button>
          <button
            v-if="mode === 'create'"
            class="btn-red"
            style="width: 140px; height: 45px"
            @click="visitTaskTodoListByOSR()"
          >
            ยืนยัน
          </button>
          <button
            v-if="mode === 'show'"
            class="btn-red-outline"
            style="width: 140px; height: 45px"
            @click="dialog = false"
          >
            ปิด
          </button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DialogImgPreview from '@/components/dialog/DialogImgPreview.vue'

export default {
  components: {
    DialogImgPreview,
  },
  props: {
    mode: {
      type: String,
      default: 'create', // create, show
    },
    data: {
      type: Object,
      default: () => {},
    },
    bpDetail: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialog: false,
      files: [],
      isRecording: false,
      note: '',
      bidStatus: '1', // 1 = win, 2 = loss
      reasonGroupId: '',
      reasonGroupList: [],
    }
  },
  computed: {
    imgPreview() {
      if (this.mode === 'create') {
        return this.files
      }
      return this.data.image
    },
    recognition() {
      const SpeechRecognize =
        window.SpeechRecognition || window.webkitSpeechRecognition
      const recognition = new SpeechRecognize()
      recognition.lang = 'th-TH'
      return recognition
    },
  },
  mounted() {
    this.voiceRecorder()
  },
  methods: {
    async getReasonGroup() {
      try {
        const res = await this.$axios.post(
          `${this.$baseAPIControl}/dropdown/getReasonGroup`,
          {},
          { headers: this.setheaders },
        )
        if (res.status === 200) {
          this.reasonGroupList = res.data.items
        }
      } catch (error) {
        console.error(error)
      }
    },
    async visitTaskTodoListByOSR() {
      try {
        // validate form
        // reason group required
        if (this.data.task_type === '3' && this.bidStatus === '2') {
          const validate = this.$refs.formRef.validate()
          if (!validate) throw new Error('form invalid')
        }

        const payload = {
          todolist_id: this.data.todo_id,
          winloss: this.data.task_type === '3' ? this.bidStatus : '', // ถ้า task_type =  "3" => เสนอราคา ให้ส่ง win = 1 , loss = 2
          reason_group: this.reasonGroupId, //ถ้า winnloss =  "2" => loss ให้ required field
          reason_detail: this.note,
          pic: this.files.map((item) => ({
            name: item.file_name,
            file: item.file_img,
          })),
        }

        const res = await this.$axios.post(
          `${this.$baseAPIControl}/todolist/visitTaskTodolistByOSR`,
          payload,
          { headers: this.setheaders },
        )

        if (res.status === 200) {
          Swal.fire({
            icon: 'success',
            title: 'ทำรายการสำเร็จ',
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            this.dialog = false
            this.$emit('closeDialog')
          })
        }
      } catch (error) {
        console.error(error)
      }
    },
    voiceRecorder() {
      this.recognition.addEventListener('result', (e) => {
        this.note += e.results[0][0].transcript
      })
      this.recognition.addEventListener('end', (e) => {
        if (this.isRecording) {
          this.recognition.start()
        }
      })
    },
    voiceRecorderStart() {
      this.recognition.start()
      this.isRecording = true
    },
    voiceRecorderStop() {
      this.recognition.stop()
      this.isRecording = false
    },
    openDialog() {
      this.dialog = true

      if (this.mode === 'create' && this.data.task_type === '3') {
        this.getReasonGroup()
      }
    },
    fileChange() {
      // convert file to base64
      const file = this.$refs.fileRef.files[0]
      if (file) {
        const reader = new FileReader()
        reader.onload = (event) => {
          // upload to server
          this.files.push({
            file_img: event.target.result,
            file_name: file.name,
          })
        }
        reader.readAsDataURL(file)
      }
      // reset input
      this.$refs.fileRef.value = ''
    },
    removeImg(index) {
      this.files = this.files.filter((_, i) => i !== index)
    },
  },
}
</script>

<style lang="scss" scoped>
.bid-type {
  flex-grow: 1;
  flex-shrink: 0;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  color: #858585;
  border: 1px solid #dfdfdf;
  background: #fff;
  cursor: pointer;
  &--active {
    color: #a50200;
    border: 1px solid #a50200;
    background: #fef2f3;
  }
}

.btn-box {
  width: 32px;
  height: 32px;
  border: 1px solid #ececec;
  background: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.todo-textarea {
  width: 100%;
  height: 150px;
  border-radius: 4px;
  border: 1px solid #ececec;
  background: #fff;
  padding: 12px;
}

.img-upload {
  object-fit: cover;
  width: 100%;
  height: 72px;
  border-radius: 8px;
}
.img-upload-remove {
  cursor: pointer;
  position: absolute;
  top: 16px;
  right: 16px;
  background: #fff;
  border-radius: 4px;
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.task-type {
  border-radius: 4px;
  padding: 2px 12px;
  font-size: 14px;
  font-weight: 500;
  &--win {
    @extend .task-type;
    background: #edf8ec;
    color: #259b12;
  }
  &--loss {
    @extend .task-type;
    background: #feeced;
    color: #ff5252;
  }
}
</style>
